import { Check } from "lucide-react";
import { ContactForm } from "./ContactForm";

export function LandingCTA() {
  return (
    <section id="contact" className="py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 landing-hero-gradient">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-raven-electric/20 blur-3xl animate-pulse" />
      </div>

      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Column - Information */}
          <div className="space-y-8">
            <div className="animate-fade-in">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
                <span className="landing-gradient-text">Únete a Empresas del Sector</span>
                <br />
                <span className="text-foreground">que ya Confían en RAVEN</span>
              </h2>
              <p className="text-lg text-muted-foreground">
                Probado y perfeccionado por profesionales como tú
              </p>
            </div>

            <div className="space-y-4 animate-fade-in" style={{animationDelay: '0.2s'}}>
              {[
                "Demo gratuita personalizada de 30 minutos",
                "Operativo al instante - sin esperas",
                "Migración de datos existentes (opcional)",
                "Capacitación para todo tu equipo",
                "Soporte técnico prioritario",
              ].map((benefit, index) => (
                <div key={index} className="flex items-start gap-3 group">
                  <div className="w-6 h-6 rounded-full bg-gradient-to-br from-raven-electric to-raven-violet flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  <p className="text-foreground font-medium">{benefit}</p>
                </div>
              ))}
            </div>

            <div className="landing-glass-card p-6 animate-fade-in" style={{animationDelay: '0.4s'}}>
              <p className="text-sm text-muted-foreground italic">
                "Participé en el desarrollo de RAVEN desde el principio. Ver cómo mis sugerencias se convertían en funcionalidades reales fue increíble. Ahora gestiono toda mi empresa desde el móvil, incluso sin conexión en sótanos y parkings."
              </p>
              <p className="text-sm font-semibold text-foreground mt-3">
                — Empresario, Seguridad y Contraincendios
              </p>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div 
            className="landing-glass-card p-8 animate-scale-in" 
            style={{animationDelay: '0.3s'}}
          >
            <h3 className="text-2xl font-bold mb-2">Solicita tu Demo Gratuita</h3>
            <p className="text-muted-foreground mb-6">
              Completa el formulario y nos pondremos en contacto contigo en menos de 24 horas.
            </p>
            <ContactForm />
          </div>

        </div>
      </div>
    </section>
  );
}
